export default "__VITE_ASSET__CbdAu_O1__"